import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  useEffect(() => {
    document.title = '404 Page'
  }, [])
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-6 text-center">
          <img
            src="../images/404.svg"
            alt="Page not found"
            className="w-64 h-64 mx-auto mb-6"
          />
          <h1 className="text-4xl font-bold text-gray-800 mb-2">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-gray-600 mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <button
            onClick={() => navigate(-1)}
            className="bg-[#ff7010] hover:bg-[#e6650d] text-white font-medium py-2 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/dealdashboard')}
            className="ml-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-6 rounded-full transition duration-300 ease-in-out"
          >
            Home Page
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
